import { configureEcho, echo } from '@laravel/echo-react';
import { INTERNAL_V1, damRequest, getApiPort, getHostname, setSocketIdGetter } from '@/hooks/damRequest';

let getAccessToken: (() => Promise<string>) | null = null;

export const setEchoTokenGetter = (tokenGetter: () => Promise<string>) => {
  getAccessToken = tokenGetter;
};

/**
 * Lets `damRequest` stamp every call with the live socket id, so the backend can keep a
 * user's own actions off their own websocket. Read lazily: the id only exists once the
 * connection is up, and it changes on reconnect.
 */
setSocketIdGetter(() => {
  try {
    return echo().socketId();
  } catch {
    // Echo is configured at import time but has no connection until the app authenticates.
    return undefined;
  }
});

configureEcho({
  broadcaster: 'reverb',
  key: process.env.NEXT_PUBLIC_REVERB_APP_KEY ?? 'my-app-key',
  wsHost: getHostname(),
  wsPort: process.env.NODE_ENV === 'development' ? getApiPort() : 443,
  wssPort: process.env.NODE_ENV === 'development' ? getApiPort() : 443,
  wsPath: '/ws',
  forceTLS: true,
  enabledTransports: ['ws', 'wss'],
  authorizer: (channel: any) => {
    return {
      authorize: async (socketId: string, callback: any) => {
        try {
          if (!getAccessToken) {
            callback(new Error('Token getter not initialized'), null);
            return;
          }

          const token = await getAccessToken();

          const data = await damRequest('POST', `${INTERNAL_V1}/broadcasting/auth`, token, {
            body: {
              socket_id: socketId,
              channel_name: channel.name,
            },
          });

          callback(null, data);
        } catch (error) {
          callback(error, null);
        }
      },
    };
  },
});
